const VERIFIER_KEY = 'filo:auth:pkce-verifier';
const STATE_KEY = 'filo:auth:state';

const base64Url = (bytes: Uint8Array): string => {
  let value = '';
  bytes.forEach((byte) => { value += String.fromCharCode(byte); });
  return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const randomValue = (length = 48): string => {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return base64Url(bytes);
};

export const createPkceRequest = async () => {
  const verifier = randomValue(64);
  const state = randomValue(32);
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  sessionStorage.setItem(VERIFIER_KEY, verifier);
  sessionStorage.setItem(STATE_KEY, state);
  return { verifier, state, challenge: base64Url(new Uint8Array(digest)) };
};

export const consumePkceRequest = (state: string) => {
  const expectedState = sessionStorage.getItem(STATE_KEY);
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);
  if (!expectedState || !verifier || state !== expectedState) {
    throw new Error('ログイン要求を検証できませんでした。もう一度ログインしてください');
  }
  return verifier;
};
